import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// TODO: Uncomment Tab imports when basic and services pages are implemented
// import { Box, Button, Flex, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useToast } from '@bonusly/design-system';
import { Box, Button, Flex, Spinner, Text, useToast } from '@bonusly/design-system';

// import { useBuildRecognizeURL } from '@bonusly/url';

import { FormSection } from '../../components/form/form-section';
// import { Route } from '../../modules/top-navbar/config/router';
import { useUpdateUserSettings, useUserSettings } from '../../queries/identity';
import { NotificationsSettingsForm } from './notifications-settings-form';
import { NotificationSettings } from './types';
import { backendToFrontend, frontendToBackend } from './utils/notification-settings-mapper';

export const UserSettings = () => {
	const { t } = useTranslation('user_settings');
	const toast = useToast();
	// const recognizeURL = useBuildRecognizeURL();
	const { data: rawSettings, isLoading } = useUserSettings();
	const [currentSettings, setCurrentSettings] = useState<NotificationSettings | null>(null);

	const initialSettings = useMemo(() => (rawSettings ? backendToFrontend(rawSettings) : null), [rawSettings]);

	const { mutate, isLoading: isSaving } = useUpdateUserSettings();

	const handleSave = () => {
		if (currentSettings) {
			mutate(frontendToBackend(currentSettings), {
				onSuccess: () => {
					setCurrentSettings(null); // Reset to disable button after successful save
					toast({
						title: t('toast.success.title'),
						description: t('toast.success.description'),
						status: 'success',
						duration: 3000,
						isClosable: true,
					});
				},
				onError: (error) => {
					toast({
						title: t('toast.error.title'),
						description: error instanceof Error ? error.message : t('toast.error.description'),
						status: 'error',
						duration: 5000,
						isClosable: true,
					});
				},
			});
		}
	};

	if (isLoading) {
		return (
			<Flex justify="center" align="center" py={8} minH="400px">
				<Spinner size="lg" />
			</Flex>
		);
	}

	if (!initialSettings) {
		return (
			<Flex justify="center" align="center" py={8} minH="400px">
				<Text>{t('noSettingsAvailable')}</Text>
			</Flex>
		);
	}
	const settingsToDisplay = currentSettings ?? initialSettings;

	return (
		<Flex justify="center" py={8}>
			<FormSection px={4} py={6} width="70%">
				{/* TODO: Uncomment tabs when other tabs are implemented
				<Tabs variant="line">
					<TabList mb={4} borderBottom="none">
						<Tab>{t('tabs.basic')}</Tab>
						<Tab>{t('tabs.notifications')}</Tab>
						<Tab>{t('tabs.services')}</Tab>
					</TabList>

					<TabPanels>
						<TabPanel>
							<Box>
								<Text mb={4}>{t('comingSoon')}</Text>
								<Button as="a" href={recognizeURL(Route.Settings)} variant="solid" size="sm">
									{t('goToCurrentPages')}
								</Button>
							</Box>
						</TabPanel>
						<TabPanel px={0}>
							<NotificationsSettingsForm settings={settingsToDisplay} onChange={setCurrentSettings} isDisabled={isSaving} />
							<Box mt={4}>
								<Button colorScheme="primary" size="md" onClick={handleSave} isLoading={isSaving} isDisabled={!currentSettings || isSaving}>
									{t('saveChanges')}
								</Button>
							</Box>
						</TabPanel>
						<TabPanel>
							<Box>
								<Text mb={4}>{t('comingSoon')}</Text>
								<Button as="a" href={recognizeURL(Route.Settings)} variant="solid" size="sm">
									{t('goToCurrentPages')}
								</Button>
							</Box>
						</TabPanel>
					</TabPanels>
				</Tabs>
				*/}
				<NotificationsSettingsForm settings={settingsToDisplay} onChange={setCurrentSettings} isDisabled={isSaving} />
				<Box mt={4}>
					<Button colorScheme="primary" size="md" onClick={handleSave} isLoading={isSaving} isDisabled={!currentSettings || isSaving}>
						{t('saveChanges')}
					</Button>
				</Box>
			</FormSection>
		</Flex>
	);
};
